import { render } from "./FilterTabs.vue?vue&type=template&id=25b0e7c2&scoped=true"
import script from "./FilterTabs.vue?vue&type=script&lang=js"
export * from "./FilterTabs.vue?vue&type=script&lang=js"

import "./FilterTabs.vue?vue&type=style&index=0&id=25b0e7c2&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b0e7c2"]])

export default __exports__